import { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from "react";

interface SimpleButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: ReactNode;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

export const SimpleButton = ({
  children,
  disabled = false,
  type = "button",
  ...props
}: SimpleButtonProps) => {
  return (
    <button
      type={type}
      {...props}
      className={`ml-auto px-4 py-3 border border-transparent rounded-md shadow-sm text-xs font-bold uppercase tracking-wider text-white ${
        // users.length >= 5
        // ? "bg-gray-300 cursor-not-allowed"
        // :
        "bg-blue-700 hover:bg-blue-800"
      }`}
      // disabled={!userName || !userEmail}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
